/* eslint-disable @angular-eslint/no-conflicting-lifecycle */
import { LogService } from "../../../../common/services/logging";

import { VolumeService } from "../../shared/components/volume/volume.service";
import { CallAudioService } from "../../call/call-audio.service";
import { SupportService } from "../../../../common/services/support/support.service";

import { Component, Input, OnInit, OnDestroy, OnChanges, DoCheck } from "@angular/core";
import { Subscription } from "rxjs";

@Component({
  selector: "onsip-instacall-volume",
  templateUrl: "./volume.component.html",
  styleUrls: ["./volume.scss"],
  standalone: false
})
export class VolumeComponent implements OnInit, OnDestroy, OnChanges, DoCheck {
  @Input() call: string | undefined;

  volumeBar = 75;
  volumeSliderBackground = "";
  private previousVolume = 80;
  private defaultVolume = 75;
  private mutedVolume: any;
  private unsubscriber = new Subscription();

  constructor(
    private log: LogService,
    private volumeService: VolumeService,
    private callAudioService: CallAudioService,
    private supportService: SupportService
  ) {}

  ngOnInit(): void {
    const audioInfo: any = this.call && this.callAudioService.findInfo(this.call);

    if (audioInfo && audioInfo.volume) {
      this.volumeBar = parseInt(audioInfo.volume);
    } else {
      this.volumeBar = this.defaultVolume;
    }

    this.unsubscriber.add(
      this.volumeService.state.subscribe(state => {
        this.defaultVolume = state.defaultVolume;
        this.volumeBar = state.defaultVolume;
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscriber.unsubscribe();
  }

  ngOnChanges(changesObj: any): void {
    if (changesObj.call && this.call) {
      const audioInfo: any = this.callAudioService.findInfo(this.call);

      if (audioInfo) {
        this.volumeBar = parseInt(audioInfo.volume);
      } else {
        this.volumeBar = this.defaultVolume;
      }
    }
  }

  ngDoCheck(): void {
    if (this.volumeBar !== this.previousVolume) {
      if (this.volumeBar === undefined) {
        this.volumeBar = this.previousVolume;
        return;
      }

      if (this.volumeBar === this.previousVolume) {
        this.volumeSliderBackground = this.getBackgroundStyle(this.volumeBar, "#73cfff", "#4d5c7f");
        return;
      }

      if (isNaN(this.volumeBar) || this.volumeBar < 0 || this.volumeBar > 100) {
        this.log.error(
          "volumeComponent -- volume changed to invalid value '",
          this.volumeBar,
          "'. should be [0-100]."
        );
        this.volumeBar = this.previousVolume;
        return;
      }

      if (this.call) {
        this.volumeService.setCallVolume(this.call, this.volumeBar);
      } else {
        this.volumeService.setDefaultVolume(this.volumeBar);
      }

      if (this.volumeBar > 0) {
        // unmute (volume changed while muted)
        this.mutedVolume = undefined;
      }

      this.volumeSliderBackground = this.getBackgroundStyle(this.volumeBar, "#73cfff", "#4d5c7f");
      this.previousVolume = this.volumeBar;
    }
  }

  volumeMute(): void {
    if (this.volumeBar === 0) {
      // unmute
      this.volumeBar = this.mutedVolume || 50;
      this.mutedVolume = undefined;
    } else {
      // mute
      this.mutedVolume = this.volumeBar === 0 ? undefined : this.volumeBar;
      this.volumeBar = 0;
    }
  }

  onKeyPress(event: any): void {
    event.stopImmediatePropagation();

    if (event.charCode === 38 && this.volumeBar < 100) {
      // up arrow
      this.volumeBar++;
    } else if (event.charCode === 40 && this.volumeBar > 0) {
      // down arrow
      this.volumeBar--;
    }
  }

  onClick(event: any): void {
    event.stopImmediatePropagation();
  }

  getBackgroundStyle(barValue: any, barColor: string, barBackgroundColor: string): string {
    const bgLeft: string = " " + barColor + " ",
      bgRight: string = " " + barBackgroundColor + " ";
    let bgStyle: string;

    barValue = parseInt(barValue);

    if (this.supportService.getBrowser().name === "chrome") {
      bgStyle =
        "-webkit-gradient(linear, left top, right top, color-stop(0%," +
        bgLeft +
        "), color-stop(" +
        barValue +
        "%," +
        bgLeft +
        "), color-stop(" +
        (barValue + 1) +
        "%," +
        bgRight +
        "), color-stop(100%," +
        bgRight +
        "))";
    } else if (this.supportService.getBrowser().name === "firefox") {
      bgStyle =
        "-moz-linear-gradient(left," +
        bgLeft +
        "0%," +
        bgLeft +
        barValue +
        "%," +
        bgRight +
        (barValue + 1) +
        "%," +
        bgRight +
        "100%)";
    } else {
      bgStyle =
        "linear-gradient(to right, " +
        bgLeft +
        " " +
        barValue +
        "%, " +
        bgRight +
        " " +
        (barValue + 1) +
        "%, " +
        bgRight +
        " 100%)";
    }
    this.log.debug("volumeComponent:", bgStyle);
    return bgStyle;
  }

  setHoverBackground(active: boolean): void {
    if (active) {
      this.volumeSliderBackground = this.getBackgroundStyle(this.volumeBar, "#82c7e6", "#4d5c7f");
    } else {
      this.volumeSliderBackground = this.getBackgroundStyle(this.volumeBar, "#73cfff", "#4d5c7f");
    }
  }
}
